module.exports = __webpack_public_path__ + "fonts/tt_sushkof_demi_bold.0182428.woff2";